const businessIndex = () =>
  import ('@/business/views/index');
const businessOnboardingForm = () =>
  import ('@/business/views/onBoardingForm');

var VUE = null

export default (Router, Store, Vue) => {
  VUE = Vue
  return new Router({
    mode: 'history',
    linkActiveClass: 'is-active',
    scrollBehavior: () => ({
      y: 1
    }),
    routes: [{
      path: '/business',
      name: 'businessIndex',
      component: businessIndex,
      children: [{
        path: '/business/aboardingForm',
        name: 'businessOnboardingForm',
        component: businessOnboardingForm
      }]
    }]
  })
}



// WEBPACK FOOTER //
// ./src/router/business/index.js